(function () {
  'use strict';
  class Controller {}
  angular
    .module('actions')
    .component('productAddAction', {
      controller: Controller,
      templateUrl: 'actions/product/add/add-product.action.html',
      bindings: {
        vendorId: '<',
        teamId: '<',
        product: '<',
        then: '&',
        catch: '&'
      }
    });
}());
